export const version = '1.0.0-alpha.11'